import React from 'react';
import Image from '../Image';
import Index1 from '../../img/index1.webp';
import Index2 from '../../img/index2.webp';
import Index3 from '../../img/index3.webp';
import Index4 from '../../img/index4.webp';
import Index5 from '../../img/index5.webp';
import Index6 from '../../img/index6.webp';
import Index7 from '../../img/index7.webp';
import Index8 from '../../img/index8.webp';
import Index9 from '../../img/index9.webp';
import Index10 from '../../img/index10.webp';
import Index11 from '../../img/index11.webp';
import Index12 from '../../img/index12.webp';
import Index13 from '../../img/index13.webp';
import Index14 from '../../img/index14.webp';
import Index15 from '../../img/index15.webp';
import Index16 from '../../img/index16.webp';

function Indexed() {
    return (
      <>
        <div className='indexed_section'>
            <div className='indexed_wrapper'>
                <div className="section_hr">

                </div>
                <p className='section_title'>Indexed with:</p>

                <div className='logos_section_wrapper'>
                    <div className='logos'>
                        <div className='logos-slide'>
                            <Image src={Index1} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index2} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index3} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index4} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index5} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index6} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index7} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index8} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index9} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index10} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index11} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index12} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index13} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index14} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index15} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index16} alt="Indexed with" class="logo_slide_image" />
                        </div>
                        <div className='logos-slide'>
                            <Image src={Index1} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index2} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index3} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index4} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index5} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index6} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index7} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index8} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index9} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index10} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index11} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index12} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index13} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index14} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index15} alt="Indexed with" class="logo_slide_image" />
                            <Image src={Index16} alt="Indexed with" class="logo_slide_image" />
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
      </>
    );
}

export default Indexed;